import type { Maybe } from '@shared/utils';
import { ImagePartial } from '@storefront/lib-global';
import { Container, IconContainer, TextInfo } from './ProductCustomShippingAndReturns.styles';

interface ProductCustomShippingAndReturns {
  image?: Maybe<string>;
  text?: Maybe<string>;
  isVisible: boolean;
}

export function ProductCustomShippingAndReturns({ isVisible, image, text }: ProductCustomShippingAndReturns) {
  if (!isVisible || !image) return null;

  return (
    <Container>
      <IconContainer>
        <ImagePartial src={image} layout="fill" useOriginalSize />
      </IconContainer>
      <TextInfo>{text}</TextInfo>
    </Container>
  );
}
